import React from 'react';
import { components } from 'react-select';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';

export const MenuList = props => {
  const { children } = props;

  return (
    <components.MenuList {...props}>
      <Box display="flex" alignItems="center" px="16" py="8">
        <Box flex={1}>
          <Text variant="smallCaps">Model Name</Text>
        </Box>

        <Text variant="smallCaps">Risk Score</Text>
      </Box>

      {children}
    </components.MenuList>
  );
};
